export default "__VITE_ASSET__58399314__"